import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import CentralEvidenceVirtualProfileSelection, {
	WorkplacePatient,
} from './CentralEvidenceVirtualProfileSelection';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSelect: (patientId: string, selectedWorkplaceId: string) => void;
	patientWorkplaces: WorkplacePatient[];
	originalId: string;
}

const CentralEvidenceVirtualProfileSelectionModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSelect,
	patientWorkplaces,
	originalId,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose}>
			<Modal.Header title='component.centralEvidenceVirtualProfileSelection.pickWorkplace' />
			<Modal.Content>
				<CentralEvidenceVirtualProfileSelection
					onSelect={onSelect}
					patientWorkplaces={patientWorkplaces}
					originalId={originalId}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default CentralEvidenceVirtualProfileSelectionModal;
